import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export const badgeVariants = cva("inline-flex items-center gap-1 rounded-md border px-1.5 py-px text-[11px] font-medium leading-4 whitespace-nowrap [&_svg]:size-3", {
  variants: {
    tone: {
      neutral: "border-border-strong bg-surface-2 text-fg-2",
      accent: "border-accent/30 bg-accent-soft text-accent",
      good: "border-good/30 bg-good/10 text-good-text",
      warning: "border-warning/40 bg-warning/10 text-warning-text",
      serious: "border-serious/40 bg-serious/10 text-serious-text",
      critical: "border-critical/40 bg-critical/10 text-critical-text",
      info: "border-info/30 bg-info/10 text-info-text",
      violet: "border-violet/30 bg-violet/10 text-violet-text",
      muted: "border-transparent bg-transparent text-fg-3",
    },
  },
  defaultVariants: { tone: "neutral" },
});

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>["tone"]>;

export function Badge({ className, tone, ...props }: ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
